export enum BusinessTemplate {
  Americas = 1,
  Row = 2,
  TotalCost = 3
}
